// deviceIdentity: v85 (MONIT 2026-10-05_0423 zad. 2): identyfikator urządzenia (UUID z fleet, F2) dla audytu usunięć
// zdjęć. Osobny moduł bez importów, żeby useApi nie importował fleet.js (fleet importuje useApi: cykl).
// Doklejany wyłącznie do DELETE zdjęcia jako parametr `?device=` (bez nowego nagłówka: CORS i kolejka bez zmian).

let current = null;

/** fleet.initFleet ustawia identyfikator po odczycie / utworzeniu w IDB. */
export function setDeviceIdentity(id) {
  current = typeof id === 'string' && id.length === 36 ? id : null;
}

export function getDeviceIdentity() {
  return current;
}

const PHOTO_DELETE_RE = /^\/api\/photos\/(slot\/)?[^/?#]+$/;

/** DELETE `/api/photos/<id>` i `/api/photos/slot/<id>` + znany identyfikator → ścieżka z `?device=`. Inne bez zmian. */
export function withDeviceParam(method, path, id = current) {
  if (method !== 'DELETE' || !id || !PHOTO_DELETE_RE.test(String(path || ''))) return path;
  return `${path}?device=${encodeURIComponent(id)}`;
}
